import React from "react";
import "./setting.sass";
import * as CONSTANTS from "../../utilities/Constants";
import IActionHeaderFormData from "../../models/shared/ActionHeaderData";
import actionHeaderActions from "../../flux/actions/ActionHeaderActions";
import { Translation } from "react-i18next";
import MeasurementSettingLanding from "./MeasurementSettingLanding";
import { Tooltip, WithTooltip, Button } from "@abb/abb-common-ux-react";
import ReportSettingLanding from "./ReportSettingLanding";
import ThresholdSettingLanding from "./ThresholdSettingLanding";
import SampleSettingLanding from "./SampleSettingLanding";
import {
  defaultMeasurementSettingData,
  MeasurementSetting,
} from "../../models/settings/MeasurementSettings";
import settingsActions from "../../flux/actions/SettingsAction";
import triggerNotifications from "../../utilities/TriggerNotifications";
import measurementSettingStore from "../../flux/stores/settings/MeasurementSettingStore";
import autoDeleteSettingStore from "../../flux/stores/settings/GetAutoDeleteSettingStore";
import AddautoDeleteSettingStore from "../../flux/stores/settings/AddAutoDeleteSettingStore";
import UpdateAutoDeleteSettingStore from "../../flux/stores/settings/UpdateAutoDeleteSettingStore";

import { v4 as uuidv4 } from "uuid";
import IThresholdSettings from "../../models/settings/ThresholdSettings";
import thresholdSettingStore from "../../flux/stores/settings/ThresholdSettingStore";
import sampleSettingStore from "../../flux/stores/settings/SampleSettingStore";
import testBackupFolderConnectionStore from "../../flux/stores/settings/TestBackupFolderConnectionStore";
import testBackupSampleXMLFolderConnectionStore from "../../flux/stores/settings/TestBackupSampleXMLFolderConnectionStore";
import backupSettingUpdateStore from "../../flux/stores/settings/BackupSettingsUpdateStore";
import ISampleSettings from "../../models/settings/SampleSettings";
import settingsGeneralFormStore from "../../flux/stores/settings/GeneralFormStore";
import loadingActions from "../../flux/actions/LoadingActions";
import settingsThresholdFormStore from "../../flux/stores/settings/ThresholdFormStore";
import settingsSampleFormStore from "../../flux/stores/settings/SampleFormStore";
import BackupRestoreSettingLanding from "./BackupRestoreSettingLanding";
import IBackupRestoreSetting from "../../models/settings/BackupRestoreSettings";
import _ from "lodash";
import graphSettingStore from "../../flux/stores/settings/GraphSettingStore";
import logoSettingStore from "../../flux/stores/settings/LogoSettingStore";
import BackupSampleXML from "./BackupSampleXML";
import testBackupXMLFolderConnectionStore from "../../flux/stores/settings/testBackupXMLFolderConnectionStore";
import backupSettingUpdateXMLStore from "../../flux/stores/settings/BackupSettingsUpdateXMLStore";
import generateNetworkPathConfigStore from "../../flux/stores/settings/GenerateNetworkPathConfigStore";


import History from "../../utilities/History";
import testBackupXLSFolderConnectionStore from "../../flux/stores/settings/TestBackupXLSFolderConnectionStore";
import testBackupAL1FolderConnectionStore from "../../flux/stores/settings/TestBackupAL1FolderConnectionStore";

import Authorize from "../../utilities/Authorize";
import authUtility from "../../utilities/AuthUtility";
import renderBreadcrumb from "../../utilities/Breadcrumb";
import AutoDeleteSetting from "./AutoDeleteSetting";

import { AutoDeleteSettings, defaultAutoDeleteSettingsData } from "../../models/settings/AutoDeleteSettings";

interface ISetting {
  listData: any[];
  activeId: string;
  activeItem: string;
  settings: MeasurementSetting;
  graphSettings: any[];
  imageURL: any;
  base64URL: string;
  thresholdSettings: IThresholdSettings[];
  sampleSettings: ISampleSettings[];
  backupRestoreSettings: any[];
  backupRestoreSettingsXML: any;
  backupSampleMeasurementXML: any;
  backupSampleMeasurementXLS: any;
  backupSampleMeasurementAL1: any;
  isDisable: boolean;
  isLoading: boolean;
  ipErrorSample: boolean;
  ipErrorXML: boolean;
  ipErrorXLS: boolean;
  ipErrorAL1: boolean;
  portErrorSample: boolean;
  portErrorXML: boolean;
  portErrorXLS: boolean;
  portErrorAL1: boolean;
  autoDeleteSettings: AutoDeleteSettings;
  autoDeleteFrequency: number;
  autoDeleteFrequencyId: string;
  selectedFrequencyType: string | null;
  autoDeleteTimingInHours: string;
  autoDeleteTimingInMinutes: string;
  autoDeleteInterval: number;
  autoDeleteIntervalId: string;
  selectedAutoDeleteInterval: string | null;
  isAutoDeleteOn: boolean;
}

export default class Index extends React.Component<
  { location: any },
  ISetting
> {
  private _mount = false;
  private _isValid = true;
  private _settingsData: MeasurementSetting;
  private _thresholdSettings: IThresholdSettings[];
  private _sampleSettings: any;
  private _messages: any;
  private _backupTestMessages: any;
  private _testResult: boolean;
  private _thresholdMessages: any;
  private _sampleMessages: any;
  private _backupRestoreSettings: IBackupRestoreSetting[];
  private _backupRestoreSettingsXML: any[];
  private _backupSampleMeasurementXML: any[];
  private _logoName: any;
  private _generateNetworkPathConfig: any;
  private _autoDeleteSettingsData: AutoDeleteSettings;

  constructor(props: { location: any }) {
    super(props);

    this.state = {
      listData: [
        { id: "2", name: "Report", authKey: "Reports" },
        { id: "3", name: "Threshold Limits", authKey: "ThresholdLimits" },
        { id: "5", name: "Backup and restore", authKey: "BackupAndRestore" },
        { id: "6", name: "File Export", authKey: "FileExport" },
        { id: "7", name: "Auto Delete", authKey: "AutoDelete" },
      ],
      activeId: "2",
      activeItem: "Report",
      settings: defaultMeasurementSettingData,
      graphSettings: [],
      imageURL: "",
      base64URL: "",
      thresholdSettings: [],
      sampleSettings: [],
      backupRestoreSettings: [],
      backupRestoreSettingsXML: [],
      backupSampleMeasurementXML: [],
      backupSampleMeasurementXLS: [],
      backupSampleMeasurementAL1: [],
      isDisable: false,
      isLoading: false,
      ipErrorSample: false,
      ipErrorXML: false,
      ipErrorXLS: false,
      ipErrorAL1: false,
      portErrorSample: false,
      portErrorXML: false,
      portErrorXLS: false,
      portErrorAL1: false,
      autoDeleteSettings: defaultAutoDeleteSettingsData,
      autoDeleteFrequency: 30,
      autoDeleteFrequencyId: CONSTANTS.DefaultGuid,
      selectedFrequencyType: "Days",
      autoDeleteTimingInHours: "12",
      autoDeleteTimingInMinutes: "00",
      autoDeleteInterval: 30,
      autoDeleteIntervalId: CONSTANTS.DefaultGuid,
      selectedAutoDeleteInterval: "Days",
      isAutoDeleteOn: false,
    };

    this._mount = false;
  }

  componentWillUnmount() {
    this._mount = false;
  }
  getActiveLinkByPermission() {
    if (authUtility.hasPermission(["Settings:Reports"])) {
      return this.state.listData.find((x) => x.id === "2");
    } else if (authUtility.hasPermission(["Settings:ThresholdLimits"])) {
      return this.state.listData.find((x) => x.id === "3");
    } else if (authUtility.hasPermission(["Settings:BackupAndRestore"])) {
      return this.state.listData.find((x) => x.id === "5");
    } else if (authUtility.hasPermission(["Settings:FileExport"])) {
      return this.state.listData.find((x) => x.id === "6");
    } else if (authUtility.hasPermission(["Settings:AutoDelete"])) {
      return this.state.listData.find((x) => x.id === "7");
    } else {
      return { id: "", name: "" };
    }
  }
  componentDidMount() {
    var activeLink = this.getActiveLinkByPermission();
    this.setState({
      activeId: activeLink.id,
      activeItem: activeLink.name,
    });
    this._mount = true;

    const addRequest = {
      moduleName: CONSTANTS.MODULE_SETTINGS,
      createData: {},
    } as IActionHeaderFormData;

    actionHeaderActions.common(addRequest).then();

    measurementSettingStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
      if (this._mount) {
        this._settingsData = state.data;
      }
    });

    thresholdSettingStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
      if (this._mount) {
        this._thresholdSettings = state.data;
      }
    });

    sampleSettingStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._sampleSettings = state.data;
      }
    });

    generateNetworkPathConfigStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
      if (this._mount) {
        this._backupRestoreSettings = state.data;
      }
    });

    backupSettingUpdateStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._backupTestMessages = state.message;
      }
    });

    backupSettingUpdateXMLStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._backupTestMessages = state.message;
      }
    });

    testBackupFolderConnectionStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._testResult = state.data;
        this._backupTestMessages = state.message;
      }
    });

    testBackupSampleXMLFolderConnectionStore.on(
      CONSTANTS.CHANGE_EVENT,
      (state) => {
        if (this._mount) {
          this._testResult = state.data;
          this._backupTestMessages = state.message;
        }
      }
    );

    testBackupXMLFolderConnectionStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._testResult = state.data;
        this._backupTestMessages = state.message;
      }
    });

    testBackupXLSFolderConnectionStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._testResult = state.data;
        this._backupTestMessages = state.message;
      }
    });

    testBackupAL1FolderConnectionStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._testResult = state.data;
        this._backupTestMessages = state.message;
      }
    });

    settingsGeneralFormStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._messages = state.message;
      }
    });

    settingsThresholdFormStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._thresholdMessages = state.message;
      }
    });

    settingsSampleFormStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._sampleMessages = state.message;
      }
    });

    graphSettingStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this.setState({
          graphSettings: _.orderBy(
            state.data.graphTypeDetails,
            ["name"],
            ["asc"]
          ),
        });
      }
    });

    logoSettingStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        if (state.data) {
          this.setState({
            imageURL: state.data,
          });
        }
      }
    });

    autoDeleteSettingStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
      if (this._mount) {
        this._autoDeleteSettingsData = state.data.data;
      }
    });

    this.getGeneralSettings();
    this.getGraphSetting();
    this.getLogoSetting();
  }

  onSettingChange = () => {
    if (this.state.activeItem === "Measurement") {
      return (
        <MeasurementSettingLanding
          onToggleDeviation={this.onToggleDeviation}
          onToggle={this.onToggle}
          settings={this.state.settings}
        />
      );
    } else if (this.state.activeItem === "Report") {
      return (
        <ReportSettingLanding
          settings={this.state.settings}
          graphSettings={this.state.graphSettings}
          imageURL={this.state.imageURL}
          base64URL={this.state.base64URL}
          logoName={this._logoName}
          // tslint:disable-next-line: jsx-no-lambda
          onChangeHeader={(v) => this.onChangeHeader(v)}
          // tslint:disable-next-line: jsx-no-lambda
          onChangeSubheader={(v) => this.onChangeSubheader(v)}
          // tslint:disable-next-line: jsx-no-lambda
          onChangeFooter={(v) => this.onChangeFooter(v)}
          onFileChange={(e: any) => this.onFileChange(e)}
          onChangeFileName={(v) => this.onChangeFileName(v)}
          onChangeFormat={(v) => this.onChangeFormat(v)}
          onChangeReportLocation={(v) => this.onChangeReportLocation(v)}
          onChangeAutoReport={this.onChangeAutoReport}
          onChangeValueReport={this.onChangeValueReport}
          onChangePositionReport={this.onChangePositionReport}
          onChangeReelReport={this.onChangeReelReport}
          onChangeGraphReport={this.onChangeGraphReport}
          onChangeGraphType={this.onChangeGraphType}
          onChangeGenerateXML={this.onChangeGenerateXML}
        />
      );
    } else if (this.state.activeItem === "Threshold Limits") {
      return (
        <ThresholdSettingLanding
          settings={this.state.thresholdSettings}
          setColor={(id, value) => this.setColor(id, value)}
        />
      );
    } else if (this.state.activeId === "5") {
      return (
        <BackupRestoreSettingLanding
          settings={this.state.backupRestoreSettings}
          setIsNetworkShared={(value) => this.setIsNetworkShared(value)}
          setDomain={(value) => this.setDomain(value)}
          setUserName={(value) => this.setUserName(value)}
          setPassword={(value) => this.setPassword(value)}
          setDrive={(value) => this.setDrive(value)}
          setLocation={(value) => this.setLocation(value)}
          testBackupFolderConnection={() => this.testBackupFolderConnection()}
        ></BackupRestoreSettingLanding>
      );
    } else if (this.state.activeId === "6") {
      return (
        <BackupSampleXML
          settingsXML={this.state.backupRestoreSettingsXML}
          setIsNetworkSharedXML={(value) => this.setIsNetworkSharedXML(value)}
          setDomainXML={(value) => this.setDomainXML(value)}
          setUserNameXML={(value) => this.setUserNameXML(value)}
          setPasswordXML={(value) => this.setPasswordXML(value)}
          setLocationXML={(value) => this.setLocationXML(value)}
          setIpAddressXML={(value) => this.setIpAddressXML(value)}
          setPortXML={(value) => this.setPortXML(value)}
          testBackupFolderConnectionXML={() =>
            this.testBackupFolderConnectionXML()
          }
          ipErrorSample={this.state.ipErrorSample}
          portErrorSample={this.state.portErrorSample}
          setAutoGenerateXML={(value) => this.setAutoGenerateXML(value)}

          msettingsXML={this.state.backupSampleMeasurementXML}
          msetIsNetworkSharedXML={(value) => this.msetIsNetworkSharedXML(value)}
          msetDomainXML={(value) => this.msetDomainXML(value)}
          msetUserNameXML={(value) => this.msetUserNameXML(value)}
          msetPasswordXML={(value) => this.msetPasswordXML(value)}
          msetLocationXML={(value) => this.msetLocationXML(value)}
          msetIpAddressXML={(value) => this.msetIpAddressXML(value)}
          msetPortXML={(value) => this.msetPortXML(value)}
          mtestBackupFolderConnectionXML={() =>
            this.mtestBackupFolderConnectionXML()
          }
          ipErrorXML={this.state.ipErrorXML}
          portErrorXML={this.state.portErrorXML}
          msetAutoGenerateXML={(value) => this.msetAutoGenerateXML(value)}


          msettingsXLS={this.state.backupSampleMeasurementXLS}
          msetIsNetworkSharedXLS={(value) => this.msetIsNetworkSharedXLS(value)}
          msetDomainXLS={(value) => this.msetDomainXLS(value)}
          msetUserNameXLS={(value) => this.msetUserNameXLS(value)}
          msetPasswordXLS={(value) => this.msetPasswordXLS(value)}
          msetLocationXLS={(value) => this.msetLocationXLS(value)}
          msetIpAddressXLS={(value) => this.msetIpAddressXLS(value)}
          msetPortXLS={(value) => this.msetPortXLS(value)}
          mtestBackupFolderConnectionXLS={() =>
            this.mtestBackupFolderConnectionXLS()
          }
          ipErrorXLS={this.state.ipErrorXLS}
          portErrorXLS={this.state.portErrorXLS}
          msetAutoGenerateXLS={(value) => this.msetAutoGenerateXLS(value)}


          msettingsAL1={this.state.backupSampleMeasurementAL1}
          msetIsNetworkSharedAL1={(value) => this.msetIsNetworkSharedAL1(value)}
          msetDomainAL1={(value) => this.msetDomainAL1(value)}
          msetUserNameAL1={(value) => this.msetUserNameAL1(value)}
          msetPasswordAL1={(value) => this.msetPasswordAL1(value)}
          msetLocationAL1={(value) => this.msetLocationAL1(value)}
          msetIpAddressAL1={(value) => this.msetIpAddressAL1(value)}
          msetPortAL1={(value) => this.msetPortAL1(value)}
          mtestBackupFolderConnectionAL1={() =>
            this.mtestBackupFolderConnectionAL1()
          }
          ipErrorAL1={this.state.ipErrorAL1}
          portErrorAL1={this.state.portErrorAL1}
          msetAutoGenerateAL1={(value) => this.msetAutoGenerateAL1(value)}

          enableDisableContent={this.enableDisableContent}
        ></BackupSampleXML>
      );
    } else if (this.state.activeId === "7") {
      return (
        <AutoDeleteSetting
          setAutoDelete={(value) => this.setAutoDelete(value)}
          autoDeleteSettings={this.state.autoDeleteSettings}
          setAutoDeleteFrequency={(value) => this.setAutoDeleteFrequency(value)}
          setSelectedFrequencyType={(value) => this.setSelectedFrequencyType(value)}
          setAutoDeleteTimingInHours={(value) => this.setAutoDeleteTimingInHours(value)}
          setAutoDeleteTimingInMinutes={(value) => this.setAutoDeleteTimingInMinutes(value)}
          setAutoDeleteInterval={(value) => this.setAutoDeleteInterval(value)}
          setSelectedAutoDeleteInterval={(value) => this.setSelectedAutoDeleteInterval(value)}
        />
      );
    } else {
      return (
        <SampleSettingLanding
          settings={this.state.sampleSettings}
          setName={(id, v) => this.setName(id, v)}
          onToggle={(id, v) => this.onToggleSample(id, v)}
        />
      );
    }
  };
  onSelectLink = (data: any) => {
    this.setState(
      {
        activeId: data.id,
        activeItem: data.name,
      },
      () => {
        if (this.state.activeItem === "Measurement") {
          this.setState({
            isDisable: false,
          });
          this.getGeneralSettings();
        } else if (this.state.activeItem === "Report") {
          this.setState({
            isDisable: false,
          });
          this.getGeneralSettings();
        } else if (this.state.activeItem === "Threshold Limits") {
          this.setState({
            isDisable: false,
          });
          this.getThresholdValues();
        } else if (this.state.activeItem === "Backup and restore") {
          if (!this._isValid) {
            this.setState({
              isDisable: true,
            });
          }
          this.getNetworkPath("BackupRestore");
        } else if (this.state.activeItem === "File Export") {
          if (!this._isValid) {
            this.setState({
              isDisable: true,
            });
          }
          this.getNetworkPathXML("SampleXML");
          this.getNetworkPathXMLs("MeasurementXML");
          this.getNetworkPathXLS("MeasurementXLS");
          this.getNetworkPathAL1("MeasurementAL1");
        } else if (this.state.activeItem === "Auto Delete") {
          this.getAutoDeleteSettings();
        } else {
          this.getSampleSettings();
          this.setState({
            isDisable: false,
          });
        }
      }
    );
  };

  private getThresholdValues = () => {
    loadingActions.setLoading(true);
    settingsActions
      .getThresholdReport()
      .then(() => {
        this.setState(
          {
            thresholdSettings: this._thresholdSettings,
          },
          () => loadingActions.setLoading(false)
        );
      })
      .catch((e) => {
        loadingActions.setLoading(false);
        triggerNotifications.error(e);
      });
  };

  private getGeneralSettings = () => {
    loadingActions.setLoading(true);
    settingsActions
      .getGeneral()
      .then(() => {
        this.setState(
          {
            settings: this._settingsData,
          },
          () => loadingActions.setLoading(false)
        );
      })
      .catch((e) => {
        loadingActions.setLoading(false);
        triggerNotifications.error(e);
      });
  };

  private getGraphSetting = () => {
    loadingActions.setLoading(true);
    settingsActions
      .getGraphSetting()
      .then(() => {
        this.setState(
          {
            settings: this._settingsData,
          },
          () => loadingActions.setLoading(false)
        );
      })
      .catch((e) => {
        loadingActions.setLoading(false);
        triggerNotifications.error(e);
      });
  };

  private getLogoSetting = () => {
    loadingActions.setLoading(true);
    settingsActions
      .getLogoSetting()
      .then(() => {
        this.setState(
          {
            settings: this._settingsData,
          },
          () => loadingActions.setLoading(false)
        );
      })
      .catch((e) => {
        loadingActions.setLoading(false);
        triggerNotifications.error(e);
      });
  };

  private getSampleSettings = () => {
    loadingActions.setLoading(true);
    settingsActions
      .getSampleFields()
      .then(() => {
        const sampleSettings = _.orderBy(
          this._sampleSettings,
          ["key"],
          ["asc"]
        );
        this.setState(
          {
            sampleSettings,
          },
          () => loadingActions.setLoading(false)
        );
      })
      .catch((e) => {
        loadingActions.setLoading(false);
        triggerNotifications.error(e);
      });
  };

  private getAutoDeleteSettings = () => {
    loadingActions.setLoading(true);
    settingsActions
      .getAutoDeleteSettings()
      .then(() => {
        let selectedFrequencyType;
        let selectedAutoDeleteInterval;
        switch (this._autoDeleteSettingsData.frequencyId.toUpperCase()) {
          case "64738DDF-D667-40BF-81E1-5E2EF8B2F4E7":
            selectedFrequencyType = "Days";
            break;
          case "00976150-C480-4DC6-8595-A462BBB3C8BA":
            selectedFrequencyType = "Weeks";
            break;
          case "01308485-5C73-4C43-A210-E24113C53596":
            selectedFrequencyType = "Months";
            break;
          case "8824531A-E5A1-4B17-82C8-67EC843A1F25":
            selectedFrequencyType = "Years";
            break;
          default:
            selectedFrequencyType = null;
        }

        switch (this._autoDeleteSettingsData.autoDeleteIntervalId.toUpperCase()) {
          case "64738DDF-D667-40BF-81E1-5E2EF8B2F4E7":
            selectedAutoDeleteInterval = "Days";
            break;
          case "00976150-C480-4DC6-8595-A462BBB3C8BA":
            selectedAutoDeleteInterval = "Weeks";
            break;
          case "01308485-5C73-4C43-A210-E24113C53596":
            selectedAutoDeleteInterval = "Months";
            break;
          case "8824531A-E5A1-4B17-82C8-67EC843A1F25":
            selectedAutoDeleteInterval = "Years";
            break;
          default:
            selectedAutoDeleteInterval = null;
        }

        this._autoDeleteSettingsData.selectedFrequencyType = selectedFrequencyType;
        this._autoDeleteSettingsData.selectedAutoDeleteInterval = selectedAutoDeleteInterval;
        this.setState(
          {
            autoDeleteSettings: this._autoDeleteSettingsData,
          },
          () => loadingActions.setLoading(false)
        );
      })
      .catch((e) => {
        loadingActions.setLoading(false);
        triggerNotifications.error(e);
      });
  }

  private getNetworkPath = (queryString: string) => {
    loadingActions.setLoading(true);
    settingsActions
      .getNewtorkPathConfig(queryString)
      .then((res: any) => {
        this.setState(
          {
            backupRestoreSettings: res || [],
          },
          () => loadingActions.setLoading(false)
        );
      })
      .catch((e) => {
        loadingActions.setLoading(false);
        triggerNotifications.error(e);
      });
  };

  private getNetworkPathXML = (queryString: string) => {
    loadingActions.setLoading(true);
    settingsActions
      .getNewtorkPathConfig(queryString)
      .then((res: any) => {
        this.setState(
          {
            backupRestoreSettingsXML: res || [],
          },
          () => loadingActions.setLoading(false)
        );
      })
      .catch((e) => {
        loadingActions.setLoading(false);
        triggerNotifications.error(e);
      });
  };

  private getNetworkPathXMLs = (queryString: string) => {
    loadingActions.setLoading(true);
    settingsActions
      .getNewtorkPathConfig(queryString)
      .then((res: any) => {
        this.setState(
          {
            backupSampleMeasurementXML: res || [],
          },
          () => loadingActions.setLoading(false)
        );
      })
      .catch((e) => {
        loadingActions.setLoading(false);
        triggerNotifications.error(e);
      });
  };

  private getNetworkPathXLS = (queryString: string) => {
    loadingActions.setLoading(true);
    settingsActions
      .getNewtorkPathConfig(queryString)
      .then((res: any) => {
        this.setState(
          {
            backupSampleMeasurementXLS: res || [],
          },
          () => loadingActions.setLoading(false)
        );
      })
      .catch((e) => {
        loadingActions.setLoading(false);
        triggerNotifications.error(e);
      });
  };

  private getNetworkPathAL1 = (queryString: string) => {
    loadingActions.setLoading(true);
    settingsActions
      .getNewtorkPathConfig(queryString)
      .then((res: any) => {
        this.setState(
          {
            backupSampleMeasurementAL1: res || [],
          },
          () => loadingActions.setLoading(false)
        );
      })
      .catch((e) => {
        loadingActions.setLoading(false);
        triggerNotifications.error(e);
      });
  };

  private enableDisableContent = (value: boolean, type: number) => {
    if (type === 1) {
      const backupSettings = JSON.parse(
        JSON.stringify(this.state.backupRestoreSettingsXML)
      );
      backupSettings.isActive = !backupSettings.isActive;
      this.setState({
        backupRestoreSettingsXML: backupSettings,
      });
    } else if (type === 2) {
      const backupSettings = JSON.parse(
        JSON.stringify(this.state.backupSampleMeasurementXML)
      );
      backupSettings.isActive = !backupSettings.isActive;
      this.setState({
        backupSampleMeasurementXML: backupSettings,
      });
    } else if (type === 3) {
      const backupSettings = JSON.parse(
        JSON.stringify(this.state.backupSampleMeasurementXLS)
      );
      backupSettings.isActive = !backupSettings.isActive;
      this.setState({
        backupSampleMeasurementXLS: backupSettings,
      });
    } else if (type === 4) {
      const backupSettings = JSON.parse(
        JSON.stringify(this.state.backupSampleMeasurementAL1)
      );
      backupSettings.isActive = !backupSettings.isActive;
      this.setState({
        backupSampleMeasurementAL1: backupSettings,
      });
    }
  };

  private checkFolderConnection = () => {
    const allFormat = [
      this.state.backupRestoreSettingsXML,
      this.state.backupSampleMeasurementXML,
      this.state.backupSampleMeasurementXLS,
      this.state.backupSampleMeasurementAL1,
    ];
    const a = allFormat.map((i: any) => {
      this.validateXML(i);
      return this._isValid;
    });
    let checker = a.every((v: any) => v === true);
    return checker;
  };

  private submit = async () => {
    if (this.state.activeItem === "Backup and restore") {
      this.validate();
      if (!this._isValid) {
        return;
      } else {
        settingsActions
          .testBackupFolderConnection(
            this.state.backupRestoreSettings,
            uuidv4()
          )
          .then(() => {
            settingsActions
              .networkPathConfig(
                this.state.backupRestoreSettings,
                uuidv4(),
                "BackupRestore"
              )
              .then(() => {
                triggerNotifications.success(["Settings Updated."]);
              })
              .catch((error: any) =>
                triggerNotifications.errors(error.message, error.data)
              );
          })
          .catch((error: any) =>
            triggerNotifications.errors(
              [error.message + " on Backup and restore"],
              error.data
            )
          );
      }
    }

    if (this.state.activeItem === "File Export") {
      const isValid = this.checkFolderConnection();
      if (!isValid) {
        return;
      } else {
        try {
          if (this.state.backupRestoreSettingsXML.isActive) {
            await settingsActions
              .testBackupXMLFolderConnection(
                this.state.backupRestoreSettingsXML,
                uuidv4()
              )
          }
          if (this.state.backupSampleMeasurementXML.isActive) {
            await settingsActions
              .testBackupXMLFolderConnections(
                this.state.backupSampleMeasurementXML,
                uuidv4()
              )
          }
          if (this.state.backupSampleMeasurementXLS.isActive) {
            await settingsActions
              .testBackupXLSFolderConnections(
                this.state.backupSampleMeasurementXLS,
                uuidv4()
              )
          }
          if (this.state.backupSampleMeasurementAL1.isActive) {
            await settingsActions
              .testBackupAL1FolderConnections(
                this.state.backupSampleMeasurementAL1,
                uuidv4()
              )
          }
          settingsActions
            .networkPathConfigFileExport(
              [
                this.state.backupRestoreSettingsXML,
                this.state.backupSampleMeasurementXML,
                this.state.backupSampleMeasurementXLS,
                this.state.backupSampleMeasurementAL1,
              ],
              uuidv4(),
              "SampleXML"
            )
            .then(() => {
              triggerNotifications.success(["Settings Updated."]);
            })
            .catch((error: any) =>
              triggerNotifications.errors(error.message, error.data)
            );
        } catch (error) {
          triggerNotifications.errors(
            [error.message + " on File Export"],
            error.data
          );
        }
      }
    }

    if (
      this.state.activeItem !== "File Export" &&
      this.state.activeItem !== "Backup and restore" && this.state.activeItem !== "Auto Delete"
    ) {
      settingsActions
        .submit(this.state.settings, uuidv4())
        .then(() => {
          settingsActions
            .submitThreshold(this.state.thresholdSettings, uuidv4())
            .then(() => {
              settingsActions
                .submitSampleField(this.state.sampleSettings, uuidv4())
                .then(() => {
                  triggerNotifications.success(this._messages);
                })
                .catch((error) =>
                  triggerNotifications.errors(error.message, error.data)
                );
            })
            .catch((error) =>
              triggerNotifications.errors(error.message, error.data)
            );
        })
        .catch((error) => triggerNotifications.error(error.message));
    }

    if(this.state.activeItem === "Auto Delete") {
      if(this.state.autoDeleteSettings.id === CONSTANTS.DefaultGuid) {
        settingsActions
          .postAutoDeleteSettings(this.state.autoDeleteSettings, uuidv4())
          .then(() => {
            triggerNotifications.success(["Settings Updated."]);
          })
          .catch((error) => triggerNotifications.error(error.message));
      } else{
        settingsActions
          .putAutoDeleteSettings(this.state.autoDeleteSettings, uuidv4())
          .then(() => {
            triggerNotifications.success(["Settings Updated."]);
          })
          .catch((error) => triggerNotifications.error(error.message));
      }
    }
  };

  //Measurement
  private onToggle = (v: number[]) => {
    this.setState({
      settings: {
        ...this.state.settings,
        meanTendency: v,
      },
    });
  };
  private onToggleDeviation = (v: number[]) => {
    this.setState({
      settings: {
        ...this.state.settings,
        stdDeviation: v,
      },
    });
  };

  // report functions
  onChangeAutoReport = () => {
    this.setState({
      settings: {
        ...this.state.settings,
        isAutoGenerateReport: !this.state.settings.isAutoGenerateReport,
      },
    });
  };
  onChangeValueReport = () => {
    this.setState({
      settings: {
        ...this.state.settings,
        isAutoGenerateValueReport:
          !this.state.settings.isAutoGenerateValueReport,
      },
    });
  };
  onChangePositionReport = () => {
    this.setState({
      settings: {
        ...this.state.settings,
        isAutoGeneratePositionReport:
          !this.state.settings.isAutoGeneratePositionReport,
      },
    });
  };
  onChangeReelReport = () => {
    this.setState({
      settings: {
        ...this.state.settings,
        isAutoGenerateRealReport: !this.state.settings.isAutoGenerateRealReport,
      },
    });
  };
  onChangeGraphReport = () => {
    this.setState({
      settings: {
        ...this.state.settings,
        isAutoGenerateGraphReport:
          !this.state.settings.isAutoGenerateGraphReport,
      },
    });
  };

  onChangeGraphType = (value: any) => {
    this.setState({
      settings: {
        ...this.state.settings,
        selectedGraphType: { id: value[0].value, name: value[0].label },
      },
    });
  };

  onChangeReportLocation = (value: string) => {
    this.setState({
      settings: {
        ...this.state.settings,
        reportSaveLocation: value,
      },
    });
  };
  onChangeFormat = (value: string) => {
    this.setState({
      settings: {
        ...this.state.settings,
        saveFormatPdf: value,
      },
    });
  };
  onChangeFileName = (value: string) => {
    this.setState({
      settings: {
        ...this.state.settings,
        fileNamePrefix: value,
      },
    });
  };

  onFileChange = async (event: any) => {
    event.stopPropagation();
    event.preventDefault();
    const file = event.target.files[0];
    this._logoName = event.target.files[0].name;
    if (
      !file.name.match(
        /\.(jpg|jpeg|png|gif|jfif|tif|tiff|bmp|JPG|JPEG|PNG|GIF|JFIF|BMP|TIF|TIFF)$/
      )
    ) {
      triggerNotifications.error("Please select valid image");
      return;
    }
    const base64 = (await this.convertBase64(file)) as string;
    const base64result = base64.split(",")[1];
    this.setState({
      settings: {
        ...this.state.settings,
        logo: base64result,
      },
      base64URL: base64,
    });
  };
  convertBase64 = async (file: any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        resolve(event.target.result);
      };
      reader.onerror = (err) => {
        reject(err);
      };
      reader.readAsDataURL(file);
    });
  };
  onChangeHeader = (value: string) => {
    this.setState({
      settings: {
        ...this.state.settings,
        header: value,
      },
    });
  };
  onChangeSubheader(value: string): void {
    this.setState({
      settings: {
        ...this.state.settings,
        subHeader: value,
      },
    });
  }
  onChangeFooter(value: string): void {
    this.setState({
      settings: {
        ...this.state.settings,
        footer: value,
      },
    });
  }

  // threshold
  private setColor = (id: string, value: string) => {
    const thresholdSettings = [...this.state.thresholdSettings];
    const thresholdSetting = this.state.thresholdSettings.find(
      (x) => x.id === id
    );
    const thresholdSettingIndex = this.state.thresholdSettings.findIndex(
      (x) => x.id === id
    );
    thresholdSetting.colorCode = value;
    thresholdSettings[thresholdSettingIndex] = thresholdSetting;
    this.setState({
      thresholdSettings,
    });
  };

  // sample
  private setName = (id: string, value: string) => {
    const sampleSettings = [...this.state.sampleSettings];
    const sampleSetting = this.state.sampleSettings.find((x) => x.id === id);
    const sampleSettingsIndex = this.state.sampleSettings.findIndex(
      (x) => x.id === id
    );
    sampleSetting.name = value;
    sampleSettings[sampleSettingsIndex] = sampleSetting;
    this.setState({
      sampleSettings,
    });
  };

  private onToggleSample = (id: string, value: any) => {
    const sampleSettings = this.state.sampleSettings;
    const sampleSettingsIndex = this.state.sampleSettings.findIndex(
      (x) => x.id === id
    );
    sampleSettings[sampleSettingsIndex].show = value;
    this.setState({
      sampleSettings,
    });
  };

  setIsNetworkShared(value: boolean): void {
    const backupSettings = this.state.backupRestoreSettings;
    backupSettings[0].isNetworkShared = value;
    this.setState({
      backupRestoreSettings: backupSettings,
    });
  }

  setDomain(value: string): void {
    const backupSettings = this.state.backupRestoreSettings;
    backupSettings[0].credentials.domain = value;
    this.setState({
      backupRestoreSettings: backupSettings,
    });
  }

  setUserName(value: string): void {
    const backupSettings = this.state.backupRestoreSettings;
    backupSettings[0].credentials.userName = value;
    this.setState({
      backupRestoreSettings: backupSettings,
    });
    if (
      !backupSettings[0].credentials.userName.trim() &&
      backupSettings[0].credentials.userName === ""
    ) {
      this.setState({
        isDisable: true,
      });
    } else {
      this.setState(
        {
          isDisable: false,
        },
        this.isvalidate
      );
    }
  }

  setPassword(value: string): void {
    const backupSettings = this.state.backupRestoreSettings;
    backupSettings[0].credentials.password = value;
    this.setState({
      backupRestoreSettings: backupSettings,
    });
    if (
      !backupSettings[0].credentials.password.trim() &&
      backupSettings[0].credentials.password === ""
    ) {
      this.setState({
        isDisable: true,
      });
    } else {
      this.setState(
        {
          isDisable: false,
        },
        this.isvalidate
      );
    }
  }

  setDrive(value: any): void {
    const backupSettings = this.state.backupRestoreSettings;
    backupSettings[0].drive = value;
    this.setState({
      backupRestoreSettings: backupSettings,
    });
    if (!backupSettings[0].drive.trim() && backupSettings[0].drive === "") {
      this.setState({
        isDisable: true,
      });
    } else {
      this.setState(
        {
          isDisable: false,
        },
        this.isvalidate
      );
    }
  }

  setLocation(value: string): void {
    const backupSettings = this.state.backupRestoreSettings;
    backupSettings[0].location = value;
    this.setState({
      backupRestoreSettings: backupSettings,
    });
    if (
      !backupSettings[0].location.trim() &&
      backupSettings[0].location === ""
    ) {
      this.setState({
        isDisable: true,
      });
    } else {
      this.setState(
        {
          isDisable: false,
        },
        this.isvalidate
      );
    }
  }

  testBackupFolderConnection = () => {
    this.validate();
    if (this._isValid) {
      loadingActions.setLoading(true);
      this._testResult = true;
      const backupSettings = this.state.backupRestoreSettings;
      backupSettings[0].isTestLoading = true;
      this.setState({
        backupRestoreSettings: backupSettings,
      });
      settingsActions
        .testBackupFolderConnection(this.state.backupRestoreSettings, uuidv4())
        .then(() => {
          loadingActions.setLoading(false);
          if (this._testResult) {
            triggerNotifications.success(this._backupTestMessages);
          } else {
            triggerNotifications
              .errors([CONSTANTS.TEST_FAILED_FOLDER_CONNECTION])
              .then();
          }
          const backupSettings = this.state.backupRestoreSettings;
          backupSettings[0].isTestLoading = false;
          this.setState({
            backupRestoreSettings: backupSettings,
          });
        })
        .catch((error: any) => {
          loadingActions.setLoading(false);
          triggerNotifications.errors(error.message, error.data).then();
          const backupSettings = this.state.backupRestoreSettings;
          backupSettings[0].isTestLoading = false;
          this.setState({
            backupRestoreSettings: backupSettings,
          });
        });
    }
  };

  setIsNetworkSharedXML(value: string): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupRestoreSettingsXML)
    );
    backupSettings.fileSaveType = value;
    backupSettings.domain = "";
    backupSettings.drive = "";
    backupSettings.ipAddress = "";
    backupSettings.location = "";
    backupSettings.password = "";
    backupSettings.username = "";
    if (value === "Ftp") {
      backupSettings.port = "21";
    }
    if (value === "Sftp") {
      backupSettings.port = "22";
    }
    this.setState(
      {
        backupRestoreSettingsXML: backupSettings,
        ipErrorSample: false,
        portErrorSample: false,
      },
      () => this.isvalidateXML(this.state.backupRestoreSettingsXML)
    );
  }

  setDomainXML(value: string): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupRestoreSettingsXML)
    );
    backupSettings.domain = value;
    this.setState({
      backupRestoreSettingsXML: backupSettings,
    });
  }

  setUserNameXML(value: string): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupRestoreSettingsXML)
    );
    backupSettings.username = value;
    this.setState({
      backupRestoreSettingsXML: backupSettings,
    });
    if (!backupSettings.username.trim() && backupSettings.username === "") {
      this.setState({
        isDisable: true,
      });
    } else {
      this.setState(
        {
          isDisable: false,
        },
        () => this.isvalidateXML(this.state.backupRestoreSettingsXML)
      );
    }
  }

  setPasswordXML(value: string): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupRestoreSettingsXML)
    );
    backupSettings.password = value;
    this.setState({
      backupRestoreSettingsXML: backupSettings,
    });
    if (!backupSettings.password.trim() && backupSettings.password === "") {
      this.setState({
        isDisable: true,
      });
    } else {
      this.setState(
        {
          isDisable: false,
        },
        () => this.isvalidateXML(this.state.backupRestoreSettingsXML)
      );
    }
  }

  setDriveXML(value: any): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupRestoreSettingsXML)
    );
    backupSettings.drive = value;
    this.setState({
      backupRestoreSettingsXML: backupSettings,
    });
    if (!backupSettings.drive.trim() && backupSettings.drive === "") {
      this.setState({
        isDisable: true,
      });
    } else {
      this.setState(
        {
          isDisable: false,
        },
        () => this.isvalidateXML(this.state.backupRestoreSettingsXML)
      );
    }
  }

  setLocationXML(value: string): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupRestoreSettingsXML)
    );
    backupSettings.location = value;
    this.setState({
      backupRestoreSettingsXML: backupSettings,
    });
    if (
      !backupSettings.location.trim() &&
      backupSettings.location === "" &&
      backupSettings.fileSaveType !== "Sftp" &&
      backupSettings.fileSaveType !== "Ftp"
    ) {
      this.setState({
        isDisable: true,
      });
    } else {
      this.setState(
        {
          isDisable: false,
        },
        () => this.isvalidateXML(this.state.backupRestoreSettingsXML)
      );
    }
  }

  setIpAddressXML(value: string): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupRestoreSettingsXML)
    );
    backupSettings.ipAddress = value;
    this.setState({
      backupRestoreSettingsXML: backupSettings,
    });
    if (
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
        value
      )
    ) {
      this.setState({ ipErrorSample: false })
    } else {
      this.setState({ ipErrorSample: true })
    }
    if (!backupSettings.ipAddress.trim() && backupSettings.ipAddress === "") {
      this.setState({
        isDisable: true,
      });
    } else {
      this.setState(
        {
          isDisable: false,
        },
        () => this.isvalidateXML(this.state.backupRestoreSettingsXML)
      );
    }
  }

  setPortXML(value: string): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupRestoreSettingsXML)
    );
    backupSettings.port = value;
    this.setState({
      backupRestoreSettingsXML: backupSettings,
    });
    if (value.trim() && /^[0-9]*$/g.test(value) && value.length < 6) {
      this.setState({ portErrorSample: false })
    } else {
      this.setState({ portErrorSample: true })
    }
    if (!backupSettings.port.trim() && backupSettings.port === "") {
      this.setState({
        isDisable: true,
      });
    } else {
      this.setState(
        {
          isDisable: false,
        },
        () => this.isvalidateXML(this.state.backupRestoreSettingsXML)
      );
    }
  }

  testBackupFolderConnectionXML = () => {
    this.validateXML(this.state.backupRestoreSettingsXML);

    if (this._isValid) {
      loadingActions.setLoading(true);
      this._testResult = true;
      const backupSettings = JSON.parse(
        JSON.stringify(this.state.backupRestoreSettingsXML)
      );
      backupSettings.isTestLoading = true;
      this.setState({
        backupRestoreSettingsXML: backupSettings,
      });
      settingsActions
        .testBackupXMLFolderConnection(
          this.state.backupRestoreSettingsXML,
          uuidv4()
        )
        .then(() => {
          loadingActions.setLoading(false);
          if (this._testResult) {
            triggerNotifications.success(this._backupTestMessages);
          } else {
            triggerNotifications
              .errors([CONSTANTS.TEST_FAILED_FOLDER_CONNECTION])
              .then();
          }
          const backupSettings = this.state.backupRestoreSettingsXML;
          backupSettings.isTestLoading = false;
          this.setState({
            backupRestoreSettingsXML: backupSettings,
          });
        })
        .catch((error: any) => {
          loadingActions.setLoading(false);
          triggerNotifications.errors(error.message, error.data).then();
          const backupSettings = this.state.backupRestoreSettingsXML;
          backupSettings.isTestLoading = false;
          this.setState({
            backupRestoreSettingsXML: backupSettings,
          });
        });
    }
  };

  msetIsNetworkSharedXML(value: string): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupSampleMeasurementXML)
    );
    backupSettings.fileSaveType = value;
    backupSettings.domain = "";
    backupSettings.drive = "";
    backupSettings.ipAddress = "";
    backupSettings.location = "";
    backupSettings.password = "";
    backupSettings.username = "";
    if (value === "Ftp") {
      backupSettings.port = "21";
    }
    if (value === "Sftp") {
      backupSettings.port = "22";
    }
    this.setState({
      backupSampleMeasurementXML: backupSettings,
      ipErrorXML: false,
      portErrorXML: false,
    }, () => this.isvalidateXML(this.state.backupSampleMeasurementXML));
  }

  msetIsNetworkSharedXLS(value: string): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupSampleMeasurementXLS)
    );
    backupSettings.fileSaveType = value;
    backupSettings.domain = "";
    backupSettings.drive = "";
    backupSettings.ipAddress = "";
    backupSettings.location = "";
    backupSettings.password = "";
    backupSettings.username = "";
    if (value === "Ftp") {
      backupSettings.port = "21";
    }
    if (value === "Sftp") {
      backupSettings.port = "22";
    }
    this.setState({
      backupSampleMeasurementXLS: backupSettings,
      ipErrorXLS: false,
      portErrorXLS: false,
    }, () => this.isvalidateXML(this.state.backupSampleMeasurementXLS));
  }

  msetIsNetworkSharedAL1(value: string): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupSampleMeasurementAL1)
    );
    backupSettings.fileSaveType = value;
    backupSettings.domain = "";
    backupSettings.drive = "";
    backupSettings.ipAddress = "";
    backupSettings.location = "";
    backupSettings.password = "";
    backupSettings.username = "";
    if (value === "Ftp") {
      backupSettings.port = "21";
    }
    if (value === "Sftp") {
      backupSettings.port = "22";
    }
    this.setState({
      backupSampleMeasurementAL1: backupSettings,
      ipErrorAL1: false,
      portErrorAL1: false,
    }, () => this.isvalidateXML(this.state.backupSampleMeasurementAL1));
  }

  msetDomainXML(value: string): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupSampleMeasurementXML)
    );
    backupSettings.domain = value;
    this.setState({
      backupSampleMeasurementXML: backupSettings,
    });
  }

  msetDomainXLS(value: string): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupSampleMeasurementXLS)
    );
    backupSettings.domain = value;
    this.setState({
      backupSampleMeasurementXLS: backupSettings,
    });
  }

  msetDomainAL1(value: string): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupSampleMeasurementAL1)
    );
    backupSettings.domain = value;
    this.setState({
      backupSampleMeasurementAL1: backupSettings,
    });
  }

  msetUserNameXML(value: string): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupSampleMeasurementXML)
    );
    backupSettings.username = value;
    this.setState({
      backupSampleMeasurementXML: backupSettings,
    });
    if (!backupSettings.username.trim() && backupSettings.username === "") {
      this.setState({
        isDisable: true,
      });
    } else {
      this.setState(
        {
          isDisable: false,
        },
        () => this.isvalidateXML(this.state.backupSampleMeasurementXML)
      );
    }
  }

  msetUserNameXLS(value: string): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupSampleMeasurementXLS)
    );
    backupSettings.username = value;
    this.setState({
      backupSampleMeasurementXLS: backupSettings,
    });
    if (!backupSettings.username.trim() && backupSettings.username === "") {
      this.setState({
        isDisable: true,
      });
    } else {
      this.setState(
        {
          isDisable: false,
        },
        () => this.isvalidateXML(this.state.backupSampleMeasurementXLS)
      );
    }
  }

  msetUserNameAL1(value: string): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupSampleMeasurementAL1)
    );
    backupSettings.username = value;
    this.setState({
      backupSampleMeasurementAL1: backupSettings,
    });
    if (!backupSettings.username.trim() && backupSettings.username === "") {
      this.setState({
        isDisable: true,
      });
    } else {
      this.setState(
        {
          isDisable: false,
        },
        () => this.isvalidateXML(this.state.backupSampleMeasurementAL1)
      );
    }
  }

  msetPasswordXML(value: string): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupSampleMeasurementXML)
    );
    backupSettings.password = value;
    this.setState({
      backupSampleMeasurementXML: backupSettings,
    });
    if (!backupSettings.password.trim() && backupSettings.password === "") {
      this.setState({
        isDisable: true,
      });
    } else {
      this.setState(
        {
          isDisable: false,
        },
        () => this.isvalidateXML(this.state.backupRestoreSettingsXML)
      );
    }
  }
  msetPasswordXLS(value: string): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupSampleMeasurementXLS)
    );
    backupSettings.password = value;
    this.setState({
      backupSampleMeasurementXLS: backupSettings,
    });
    if (!backupSettings.password.trim() && backupSettings.password === "") {
      this.setState({
        isDisable: true,
      });
    } else {
      this.setState(
        {
          isDisable: false,
        },
        () => this.isvalidateXML(this.state.backupSampleMeasurementXLS)
      );
    }
  }

  msetPasswordAL1(value: string): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupSampleMeasurementAL1)
    );
    backupSettings.password = value;
    this.setState({
      backupSampleMeasurementAL1: backupSettings,
    });
    if (!backupSettings.password.trim() && backupSettings.password === "") {
      this.setState({
        isDisable: true,
      });
    } else {
      this.setState(
        {
          isDisable: false,
        },
        () => this.isvalidateXML(this.state.backupSampleMeasurementAL1)
      );
    }
  }

  msetDriveXML(value: any): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupSampleMeasurementXML)
    );
    backupSettings.drive = value;
    this.setState({
      backupSampleMeasurementXML: backupSettings,
    });
    if (!backupSettings.drive.trim() && backupSettings.drive === "") {
      this.setState({
        isDisable: true,
      });
    } else {
      this.setState(
        {
          isDisable: false,
        },
        () => this.isvalidateXML(this.state.backupRestoreSettingsXML)
      );
    }
  }
  msetDriveXLS(value: any): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupSampleMeasurementXLS)
    );
    backupSettings.drive = value;
    this.setState({
      backupSampleMeasurementXLS: backupSettings,
    });
    if (!backupSettings.drive.trim() && backupSettings.drive === "") {
      this.setState({
        isDisable: true,
      });
    } else {
      this.setState(
        {
          isDisable: false,
        },
        () => this.isvalidateXML(this.state.backupSampleMeasurementXLS)
      );
    }
  }

  msetDriveAL1(value: any): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupSampleMeasurementAL1)
    );
    backupSettings.drive = value;
    this.setState({
      backupSampleMeasurementAL1: backupSettings,
    });
    if (!backupSettings.drive.trim() && backupSettings.drive === "") {
      this.setState({
        isDisable: true,
      });
    } else {
      this.setState(
        {
          isDisable: false,
        },
        () => this.isvalidateXML(this.state.backupSampleMeasurementAL1)
      );
    }
  }

  msetLocationXML(value: string): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupSampleMeasurementXML)
    );
    backupSettings.location = value;
    this.setState({
      backupSampleMeasurementXML: backupSettings,
    });
    if (
      !backupSettings.location.trim() &&
      backupSettings.location === "" &&
      backupSettings.fileSaveType !== "Sftp" &&
      backupSettings.fileSaveType !== "Ftp"
    ) {
      this.setState({
        isDisable: true,
      });
    } else {
      this.setState(
        {
          isDisable: false,
        },
        () => this.isvalidateXML(this.state.backupRestoreSettingsXML)
      );
    }
  }

  msetLocationXLS(value: string): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupSampleMeasurementXLS)
    );
    backupSettings.location = value;
    this.setState({
      backupSampleMeasurementXLS: backupSettings,
    });
    if (
      !backupSettings.location.trim() &&
      backupSettings.location === "" &&
      backupSettings.fileSaveType !== "Sftp" &&
      backupSettings.fileSaveType !== "Ftp"
    ) {
      this.setState({
        isDisable: true,
      });
    } else {
      this.setState(
        {
          isDisable: false,
        },
        () => this.isvalidateXML(this.state.backupSampleMeasurementXLS)
      );
    }
  }

  msetLocationAL1(value: string): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupSampleMeasurementAL1)
    );
    backupSettings.location = value;
    this.setState({
      backupSampleMeasurementAL1: backupSettings,
    });
    if (
      !backupSettings.location.trim() &&
      backupSettings.location === "" &&
      backupSettings.fileSaveType !== "Sftp" && backupSettings.fileSaveType !== "Ftp"
    ) {
      this.setState({
        isDisable: true,
      });
    } else {
      this.setState(
        {
          isDisable: false,
        },
        () => this.isvalidateXML(this.state.backupSampleMeasurementAL1)
      );
    }
  }

  msetIpAddressXML(value: string): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupSampleMeasurementXML)
    );
    backupSettings.ipAddress = value;
    this.setState({
      backupSampleMeasurementXML: backupSettings,
    });
    if (
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
        value
      )
    ) {
      this.setState({ ipErrorXML: false })
    } else {
      this.setState({ ipErrorXML: true })
    }
    if (!backupSettings.ipAddress.trim() && backupSettings.ipAddress === "") {
      this.setState({
        isDisable: true,
      });
    } else {
      this.setState(
        {
          isDisable: false,
        },
        () => this.isvalidateXML(this.state.backupRestoreSettingsXML)
      );
    }
  }

  msetIpAddressXLS(value: string): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupSampleMeasurementXLS)
    );
    backupSettings.ipAddress = value;
    this.setState({
      backupSampleMeasurementXLS: backupSettings,
    });
    if (
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
        value
      )
    ) {
      this.setState({ ipErrorXLS: false })
    } else {
      this.setState({ ipErrorXLS: true })
    }
    if (!backupSettings.ipAddress.trim() && backupSettings.ipAddress === "") {
      this.setState({
        isDisable: true,
      });
    } else {
      this.setState(
        {
          isDisable: false,
        },
        () => this.isvalidateXML(this.state.backupSampleMeasurementXLS)
      );
    }
  }

  msetIpAddressAL1(value: string): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupSampleMeasurementAL1)
    );
    backupSettings.ipAddress = value;
    this.setState({
      backupSampleMeasurementAL1: backupSettings,
    });
    if (
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
        value
      )
    ) {
      this.setState({ ipErrorAL1: false })
    } else {
      this.setState({ ipErrorAL1: true })
    }
    if (!backupSettings.ipAddress.trim() && backupSettings.ipAddress === "") {
      this.setState({
        isDisable: true,
      });
    } else {
      this.setState(
        {
          isDisable: false,
        },
        () => this.isvalidateXML(this.state.backupSampleMeasurementAL1)
      );
    }
  }

  msetPortXML(value: string): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupSampleMeasurementXML)
    );
    backupSettings.port = value;
    this.setState({
      backupSampleMeasurementXML: backupSettings,
    });
    if (value.trim() && /^[0-9]*$/g.test(value) && value.length < 6) {
      this.setState({ portErrorXML: false })
    } else {
      this.setState({ portErrorXML: true })
    }
    if (!backupSettings.port.trim() && backupSettings.port === "") {
      this.setState({
        isDisable: true,
      });
    } else {
      this.setState(
        {
          isDisable: false,
        },
        () => this.isvalidateXML(this.state.backupRestoreSettingsXML)
      );
    }
  }

  msetPortXLS(value: string): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupSampleMeasurementXLS)
    );
    backupSettings.port = value;
    this.setState({
      backupSampleMeasurementXLS: backupSettings,
    });
    if (value.trim() && /^[0-9]*$/g.test(value) && value.length < 6) {
      this.setState({ portErrorXLS: false })
    } else {
      this.setState({ portErrorXLS: true })
    }
    if (!backupSettings.port.trim() && backupSettings.port === "") {
      this.setState({
        isDisable: true,
      });
    } else {
      this.setState(
        {
          isDisable: false,
        },
        () => this.isvalidateXML(this.state.backupSampleMeasurementXLS)
      );
    }
  }

  msetPortAL1(value: string): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupSampleMeasurementAL1)
    );
    backupSettings.port = value;
    this.setState({
      backupSampleMeasurementAL1: backupSettings,
    });
    if (value.trim() && /^[0-9]*$/g.test(value) && value.length < 6) {
      this.setState({ portErrorAL1: false })
    } else {
      this.setState({ portErrorAL1: true })
    }
    if (!backupSettings.port.trim() && backupSettings.port === "") {
      this.setState({
        isDisable: true,
      });
    } else {
      this.setState(
        {
          isDisable: false,
        },
        () => this.isvalidateXML(this.state.backupSampleMeasurementAL1)
      );
    }
  }

  mtestBackupFolderConnectionXML = () => {
    this.validateXML(this.state.backupSampleMeasurementXML);
    if (this._isValid) {
      loadingActions.setLoading(true);
      this._testResult = true;
      const backupSettings = JSON.parse(
        JSON.stringify(this.state.backupSampleMeasurementXML)
      );
      backupSettings.isTestLoading = true;
      this.setState({
        backupSampleMeasurementXML: backupSettings,
      });
      settingsActions
        .testBackupXMLFolderConnections(
          this.state.backupSampleMeasurementXML,
          uuidv4()
        )
        .then(() => {
          loadingActions.setLoading(false);
          if (this._testResult) {
            triggerNotifications.success(this._backupTestMessages);
          } else {
            triggerNotifications
              .errors([CONSTANTS.TEST_FAILED_FOLDER_CONNECTION])
              .then();
          }
          const backupSettings = JSON.parse(
            JSON.stringify(this.state.backupSampleMeasurementXML)
          );
          backupSettings.isTestLoading = false;
          this.setState({
            backupSampleMeasurementXML: backupSettings,
          });
        })
        .catch((error: any) => {
          loadingActions.setLoading(false);
          triggerNotifications.errors(error.message, error.data).then();
          const backupSettings = JSON.parse(
            JSON.stringify(this.state.backupSampleMeasurementXML)
          );
          backupSettings.isTestLoading = false;
          this.setState({
            backupSampleMeasurementXML: backupSettings,
          });
        });
    }
  };

  mtestBackupFolderConnectionXLS = () => {
    this.validateXML(this.state.backupSampleMeasurementXLS);
    if (this._isValid) {
      loadingActions.setLoading(true);
      this._testResult = true;
      const backupSettings = JSON.parse(
        JSON.stringify(this.state.backupSampleMeasurementXLS)
      );
      backupSettings.isTestLoading = true;
      this.setState({
        backupSampleMeasurementXLS: backupSettings,
      });
      settingsActions
        .testBackupXLSFolderConnections(
          this.state.backupSampleMeasurementXLS,
          uuidv4()
        )
        .then(() => {
          loadingActions.setLoading(false);
          if (this._testResult) {
            triggerNotifications.success(this._backupTestMessages);
          } else {
            triggerNotifications
              .errors([CONSTANTS.TEST_FAILED_FOLDER_CONNECTION])
              .then();
          }
          const backupSettings = JSON.parse(
            JSON.stringify(this.state.backupSampleMeasurementXLS)
          );
          backupSettings.isTestLoading = false;
          this.setState({
            backupSampleMeasurementXLS: backupSettings,
          });
        })
        .catch((error: any) => {
          loadingActions.setLoading(false);
          triggerNotifications.errors(error.message, error.data).then();
          const backupSettings = JSON.parse(
            JSON.stringify(this.state.backupSampleMeasurementXLS)
          );
          backupSettings.isTestLoading = false;
          this.setState({
            backupSampleMeasurementXLS: backupSettings,
          });
        });
    }
  };

  mtestBackupFolderConnectionAL1 = () => {
    this.validateXML(this.state.backupSampleMeasurementAL1);
    if (this._isValid) {
      loadingActions.setLoading(true);
      this._testResult = true;
      const backupSettings = JSON.parse(
        JSON.stringify(this.state.backupSampleMeasurementAL1)
      );
      backupSettings.isTestLoading = true;
      this.setState({
        backupSampleMeasurementAL1: backupSettings,
      });
      settingsActions
        .testBackupAL1FolderConnections(
          this.state.backupSampleMeasurementAL1,
          uuidv4()
        )
        .then(() => {
          loadingActions.setLoading(false);
          if (this._testResult) {
            triggerNotifications.success(this._backupTestMessages);
          } else {
            triggerNotifications
              .errors([CONSTANTS.TEST_FAILED_FOLDER_CONNECTION])
              .then();
          }
          const backupSettings = JSON.parse(
            JSON.stringify(this.state.backupSampleMeasurementAL1)
          );
          backupSettings.isTestLoading = false;
          this.setState({
            backupSampleMeasurementAL1: backupSettings,
          });
        })
        .catch((error: any) => {
          loadingActions.setLoading(false);
          triggerNotifications.errors(error.message, error.data).then();
          const backupSettings = JSON.parse(
            JSON.stringify(this.state.backupSampleMeasurementAL1)
          );
          backupSettings.isTestLoading = false;
          this.setState({
            backupSampleMeasurementAL1: backupSettings,
          });
        });
    }
  };


  setAutoGenerateXML(value: number): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupRestoreSettingsXML)
    );
    backupSettings.autoGenerateType = value;
    this.setState({
      backupRestoreSettingsXML: backupSettings,
    });
  }

  msetAutoGenerateXML(value: number): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupSampleMeasurementXML)
    );
    backupSettings.autoGenerateType = value;
    this.setState({
      backupSampleMeasurementXML: backupSettings,
    });
  }

  msetAutoGenerateXLS(value: number): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupSampleMeasurementXLS)
    );
    backupSettings.autoGenerateType = value;
    this.setState({
      backupSampleMeasurementXLS: backupSettings,
    });
  }

  msetAutoGenerateAL1(value: number): void {
    const backupSettings = JSON.parse(
      JSON.stringify(this.state.backupSampleMeasurementAL1)
    );
    backupSettings.autoGenerateType = value;
    this.setState({
      backupSampleMeasurementAL1: backupSettings,
    });
  }

  isvalidate = () => {
    let networkShare = this.state.backupRestoreSettings[0].isNetworkShared;
    if (networkShare) {
      if (
        this.state.backupRestoreSettings[0].credentials.userName.trim() &&
        this.state.backupRestoreSettings[0].credentials.userName !== "" &&
        this.state.backupRestoreSettings[0].credentials.password.trim() &&
        this.state.backupRestoreSettings[0].credentials.password !== "" &&
        this.state.backupRestoreSettings[0].drive.trim() &&
        this.state.backupRestoreSettings[0].drive !== "" &&
        this.state.backupRestoreSettings[0].location.trim() &&
        this.state.backupRestoreSettings[0].location !== ""
      ) {
        this._isValid = true;
        this.setState({
          isDisable: false,
        });
      } else {
        this._isValid = false;
        this.setState({
          isDisable: true,
        });
      }
    }
  };

  isvalidateXML = (data: any) => {
    let networkShare = data.fileSaveType !== "Local";
    if (data.fileSaveType === "Network Sharing") {
      if (
        data.username?.trim() &&
        data.username !== "" &&
        data.password?.trim() &&
        data.password !== "" &&
        data.location?.trim() &&
        data.location !== ""
      ) {
        this._isValid = true;
        this.setState({
          isDisable: false,
        });
      } else {
        this._isValid = false;
        this.setState({
          isDisable: true,
        });
      }
    }
    if (data.fileSaveType === "Sftp" || data.fileSaveType === "Ftp") {
      if (
        data.username?.trim() &&
        data.username !== "" &&
        data.password?.trim() &&
        data.password !== "" &&
        data.ipAddress?.trim() &&
        data.ipAddress !== "" &&
        data.port?.trim() &&
        data.port !== ""
      ) {
        this._isValid = true;
        this.setState({
          isDisable: false,
        });
      } else {
        this._isValid = false;
        this.setState({
          isDisable: true,
        });
      }
    }

    if (data.fileSaveType === "Local") {
      if (data.location.trim() && data.location !== "") {
        this._isValid = true;

        this.setState({
          isDisable: false,
        });
      } else {
        this._isValid = false;
        this.setState({
          isDisable: true,
        });
      }
    }
  };

  validate = () => {
    this._isValid = true;
    let msg = "";

    let networkShare = this.state.backupRestoreSettings[0].isNetworkShared;
    if (networkShare) {
      if (
        !this.state.backupRestoreSettings[0].credentials.userName.trim() &&
        this.state.backupRestoreSettings[0].credentials.userName === ""
      ) {
        this._isValid = false;
        if (msg.length > 0) {
          msg = msg + ", " + CONSTANTS.LABLE_INSTRUMENT_USERNAME;
        } else {
          msg = CONSTANTS.LABLE_INSTRUMENT_USERNAME;
        }
      }
      if (
        !this.state.backupRestoreSettings[0].credentials.password.trim() &&
        this.state.backupRestoreSettings[0].credentials.password === ""
      ) {
        this._isValid = false;
        if (msg.length > 0) {
          msg = msg + ", " + CONSTANTS.LABLE_INSTRUMENT_PASSWORD;
        } else {
          msg = CONSTANTS.LABLE_INSTRUMENT_PASSWORD;
        }
      }
      if (
        !this.state.backupRestoreSettings[0].drive.trim() &&
        this.state.backupRestoreSettings[0].drive === ""
      ) {
        this._isValid = false;
        if (msg.length > 0) {
          msg = msg + ", " + CONSTANTS.LABEL_DRIVE;
        } else {
          msg = CONSTANTS.LABEL_DRIVE;
        }
      }
      if (
        !this.state.backupRestoreSettings[0].location.trim() &&
        this.state.backupRestoreSettings[0].location === ""
      ) {
        this._isValid = false;
        if (msg.length > 0) {
          msg = msg + ", " + CONSTANTS.LABEL_LOCATION;
        } else {
          msg = CONSTANTS.LABEL_LOCATION;
        }
      } else {
        if (
          this.state.backupRestoreSettings[0].isNetworkShared &&
          CONSTANTS.NETWORKSHARINGREGEXP.test(
            this.state.backupRestoreSettings[0].location.trim()
          )
        ) {
          this._isValid = false;
          if (msg.length > 0) {
            msg = msg + ", " + CONSTANTS.LABEL_INVALIDNETWORK_LOCATION;
          } else {
            msg = CONSTANTS.LABEL_INVALIDNETWORK_LOCATION;
          }
        }
      }
    } else {
      if (
        !this.state.backupRestoreSettings[0].location.trim() &&
        this.state.backupRestoreSettings[0].location === ""
      ) {
        this._isValid = false;
        msg = CONSTANTS.LABEL_LOCATION;
      } else {
        if (
          !this.state.backupRestoreSettings[0].isNetworkShared &&
          !/^[a-zA-Z]:\\[\\\S|*\S]?.*$/gm.test(
            this.state.backupRestoreSettings[0].location.trim()
          )
        ) {
          this._isValid = false;
          if (msg.length > 0) {
            msg = msg + ", " + CONSTANTS.LABEL_INVALIDFOLDER_LOCATION;
          } else {
            msg = CONSTANTS.LABEL_INVALIDFOLDER_LOCATION;
          }
        }
      }
    }
    if (!this._isValid) {
      triggerNotifications
        .errors([msg + " " + CONSTANTS.ERROR_REQUIRED])
        .then();
    }
  };

  onChangeGenerateXML = (value: any) => {
    this.setState({
      settings: {
        ...this.state.settings,
        generateXML: value,
      },
    });
  };

  validateXML = (data: any) => {
    this._isValid = true;
    let msg = "";

    let networkShare = data.fileSaveType !== "Local";
    if (networkShare && data.isActive) {
      if (!data.username.trim() && data.username === "") {
        this._isValid = false;
        if (msg.length > 0) {
          msg = msg + ", " + CONSTANTS.LABLE_INSTRUMENT_USERNAME;
        } else {
          msg = CONSTANTS.LABLE_INSTRUMENT_USERNAME;
        }
      }
      if (!data.password.trim() && data.password === "") {
        this._isValid = false;
        if (msg.length > 0) {
          msg = msg + ", " + CONSTANTS.LABLE_INSTRUMENT_PASSWORD;
        } else {
          msg = CONSTANTS.LABLE_INSTRUMENT_PASSWORD;
        }
      }
      if (data.fileSaveType === "Network Sharing") {
        if (!data.location.trim() && data.location === "") {
          this._isValid = false;
          if (msg.length > 0) {
            msg = msg + ", " + CONSTANTS.LABEL_LOCATION;
          } else {
            msg = CONSTANTS.LABEL_LOCATION;
          }
        } else {
          if (
            data.fileSaveType !== "Local" &&
            CONSTANTS.NETWORKSHARINGREGEXP.test(data.location.trim())
          ) {
            this._isValid = false;
            if (msg.length > 0) {
              msg = msg + ", " + CONSTANTS.LABEL_INVALIDNETWORK_LOCATION;
            } else {
              msg = CONSTANTS.LABEL_INVALIDNETWORK_LOCATION;
            }
          }
        }
      }
      if (data.fileSaveType === "Ftp" || data.fileSaveType === "Sftp") {
        if (
          data.ipAddress === null ||
          (!data.ipAddress.trim() && data.ipAddress === "")
        ) {
          this._isValid = false;
          if (msg.length > 0) {
            msg = msg + ", " + CONSTANTS.LABEL_IPADDRESS;
          } else {
            msg = CONSTANTS.LABEL_IPADDRESS;
          }
        } else {
          if (
            !/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
              data.ipAddress
            )
          ) {
            this._isValid = false;
            if (msg.length > 0) {
              msg = msg + ", " + CONSTANTS.LABEL_INVALIDIPADDRESS_LOCATION;
            } else {
              msg = CONSTANTS.LABEL_INVALIDIPADDRESS_LOCATION;
            }
          }
        }
        if (data.port === null || (!data.port.trim() && data.port === "")) {
          this._isValid = false;
          if (msg.length > 0) {
            msg = msg + ", " + CONSTANTS.LABEL_PORT;
          } else {
            msg = CONSTANTS.LABEL_PORT;
          }
        } else {
          if (!/^[0-9]*$/g.test(data.port) && data.port.length > 6) {
            this._isValid = false;
            if (msg.length > 0) {
              msg = msg + ", " + CONSTANTS.LABEL_INVALIDPORT_LOCATION;
            } else {
              msg = CONSTANTS.LABEL_INVALIDPORT_LOCATION;
            }
          }
        }
      }
    } else {
      if (
        data.fileSaveType === "Local" && data.isActive &&
        !/^[a-zA-Z]:\\[\\\S|*\S]?.*$/gm.test(data.location.trim())
      ) {
        this._isValid = false;
        if (msg.length > 0) {
          msg = msg + ", " + CONSTANTS.LABEL_INVALIDFOLDER_LOCATION;
        } else {
          msg = CONSTANTS.LABEL_INVALIDFOLDER_LOCATION;
        }
      }
    }
    if (!this._isValid) {
      triggerNotifications
        .errors([msg + " " + CONSTANTS.ERROR_REQUIRED])
        .then();
    }
  };

  public breadcrumpClick = (link: string): void => {
    if (link) History.push(link);
  };

  public setAutoDelete = (value: boolean): void => {
    let autoDeleteSettings;
    if (value) {
      autoDeleteSettings = JSON.parse(JSON.stringify(this.state.autoDeleteSettings));
      autoDeleteSettings.isAutoDeleteOn = value;
    } else {
      autoDeleteSettings = {
        frequency: 30,
        frequencyId: "64738ddf-d667-40bf-81e1-5e2ef8b2f4e7",
        selectedFrequencyType: "Days",
        autoDeleteTimingInHours: 12,
        autoDeleteTimingInMinutes: 0,
        autoDeleteInterval: 30,
        autoDeleteIntervalId: "64738ddf-d667-40bf-81e1-5e2ef8b2f4e7",
        selectedAutoDeleteInterval: "Days",
        isAutoDeleteOn: false,
        samplesLastDeletedOn: null
      };
    }
    this.setState({
      autoDeleteSettings: autoDeleteSettings,
    });
  }

  public setAutoDeleteFrequency = (value: string): void => {
    const numericValue = value.replace(/[^0-9]/g, '');
    const autoDeleteSettings = JSON.parse(
      JSON.stringify(this.state.autoDeleteSettings)
    );
    autoDeleteSettings.frequency = Number(numericValue);
    this.setState({
      autoDeleteSettings: autoDeleteSettings,
    });
  }

  public setSelectedFrequencyType = (value: string): void => {
    const autoDeleteSettings = JSON.parse(
      JSON.stringify(this.state.autoDeleteSettings)
    );
    autoDeleteSettings.selectedFrequencyType = value;
    switch (value) {
      case "Days":
        autoDeleteSettings.frequencyId = "64738DDF-D667-40BF-81E1-5E2EF8B2F4E7";
        break;
      case "Weeks":
        autoDeleteSettings.frequencyId = "00976150-C480-4DC6-8595-A462BBB3C8BA";
        break;
      case "Months":
        autoDeleteSettings.frequencyId = "01308485-5C73-4C43-A210-E24113C53596";
        break;
      case "Years":
        autoDeleteSettings.frequencyId = "8824531A-E5A1-4B17-82C8-67EC843A1F25";
        break;
      default:
        autoDeleteSettings.frequencyId = null;
    }
    this.setState({
      autoDeleteSettings: autoDeleteSettings,
    });
  }

  public setAutoDeleteTimingInHours = (value: string): void => {
    const autoDeleteSettings = JSON.parse(
      JSON.stringify(this.state.autoDeleteSettings)
    );
    autoDeleteSettings.autoDeleteTimingInHours = value;
    this.setState({
      autoDeleteSettings: autoDeleteSettings,
    });
  }

  public setAutoDeleteTimingInMinutes = (value: string): void => {
    const autoDeleteSettings = JSON.parse(
      JSON.stringify(this.state.autoDeleteSettings)
    );
    autoDeleteSettings.autoDeleteTimingInMinutes = value;
    this.setState({
      autoDeleteSettings: autoDeleteSettings,
    });
  }

  public setAutoDeleteInterval = (value: string): void => {
    const numericValue = value.replace(/[^0-9]/g, '');
    const autoDeleteSettings = JSON.parse(
      JSON.stringify(this.state.autoDeleteSettings)
    );
    autoDeleteSettings.autoDeleteInterval = Number(numericValue);
    this.setState({
      autoDeleteSettings: autoDeleteSettings,
    });
  }

  public setSelectedAutoDeleteInterval = (value: string): void => {
    const autoDeleteSettings = JSON.parse(
      JSON.stringify(this.state.autoDeleteSettings)
    );
    autoDeleteSettings.selectedAutoDeleteInterval = value;
    switch (value) {
      case "Days":
        autoDeleteSettings.autoDeleteIntervalId = "64738DDF-D667-40BF-81E1-5E2EF8B2F4E7";
        break;
      case "Weeks":
        autoDeleteSettings.autoDeleteIntervalId = "00976150-C480-4DC6-8595-A462BBB3C8BA";
        break;
      case "Months":
        autoDeleteSettings.autoDeleteIntervalId = "01308485-5C73-4C43-A210-E24113C53596";
        break;
      case "Years":
        autoDeleteSettings.autoDeleteIntervalId = "8824531A-E5A1-4B17-82C8-67EC843A1F25";
        break;
      default:
        autoDeleteSettings.autoDeleteIntervalId = null;
    }
    this.setState({
      autoDeleteSettings: autoDeleteSettings,
    });
  }


  public render() {
    return (
      <Translation>
        {(t) => (
          <div className="layout-margin">
            <div className="layout-container">
              <div className="container-box mt-3 align-self-center rounded-sm rounded-lg submit-header-fixed submit-header-setting">
                <div className="col-12">
                  {renderBreadcrumb(
                    [
                      { text: t("Home"), link: "/samplenew", bolder: false },
                      { text: t(CONSTANTS.MENU_CONFIG), link: null, bolder: false },
                      { text: t(CONSTANTS.MODULE_SETTINGS), link: null, bolder: true }
                    ], "float-left mt-1")
                  }
                  <div className="float-right">
                    <div className="float-right ml-5">
                      <Button
                        type="primary-black"
                        shape="pill"
                        className="spinner-position"
                        text={t(CONSTANTS.BUTTON_SAVE)}
                        icon="abb/check-mark"
                        onClick={this.submit}
                        disabled={this.state.isDisable}
                        isLoading={this.state.isLoading}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-3 p-4 main-container-class">
                <div className="float-left setting-sidebar">
                  <ul className="sidebar-nav-ul sidebar-list-layout overflow-auto list-background sidebar-setting">
                    {(this.state.listData || []).map((d, key) => {
                      return (
                        <Authorize
                          scopes={[
                            `${CONSTANTS.AUTHKEY_SETTINGS}:${d.authKey}`,
                          ]}
                        >
                        <li
                          key={key}
                          onClick={() => this.onSelectLink(d)}
                          className={
                            this.state.activeId === d.id
                              ? "active-link tooltip-bottom"
                              : "tooltip-bottom"
                          }
                          data-tooltip={d.name}
                        >
                          <div className="sidebar-items p-1 mb-0">
                            <WithTooltip>
                              <span className="text-ellipsis width-11rem">
                                {t(d.name)}
                              </span>
                              <Tooltip>{t(d.name)}</Tooltip>
                            </WithTooltip>
                          </div>
                        </li>
                      </Authorize>
                      );
                    })}
                  </ul>
                </div>
                <div className="no-padding float-right setting-landing">
                  {this.onSettingChange()}
                </div>
                <div className="clearfix" />
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}
